module.exports = __webpack_public_path__ + "img/ep-arc-en-ciel.bb4c5808.jpg";